import { getUri } from '../../utils/index.js';
// 数据协议 - 导航
export const navMap = [
  {
    link: "/",
    title: "首页",
    id: 1,
    isExternal: false,
  },
  {
    link: "/productor",
    title: "产品介绍",
    id: 2,
    isExternal: false,
  },
  {
    link: "/cookbook",
    title: "好侍菜谱",
    id: 3,
    isExternal: false,
  },
  {
    link: getUri('/index/company/index.html'),
    title: "公司介绍",
    id: 4,
    isExternal: true,
  },
  {
    link: getUri('/index/business/index.html'),
    title: "业务合作",
    id: 5,
    isExternal: true,
  },
  {
    link: getUri('/index/company/contact.html'),
    title: "联系我们",
    id: 6,
    isExternal: true,
  },
];
